module.exports = __webpack_public_path__ + "img/EyeLab_Logo2.10916be8.jpg";